export default "__VITE_ASSET__CNFhnv4X__"